import React, { Component } from 'react'
import Select from 'react-select'

class BlogSearch extends Component {

  state = {
    topic: null,
  }

  componentDidMount() {
    const { categories } = this.props;
    if (typeof window === 'undefined') return
    const searchParams = new URLSearchParams(window?.location?.search);
    const categorySlug = searchParams.get("category"); // Extract category parameter

    let topic = null;
    if (categories && categorySlug) {
      let category = categories.find(el => el.slug === categorySlug);
      if (category) {
        topic = { label: category.name, value: category.slug };
      }
    }

    this.setState({ topic }, this.updateList);
  }

  componentDidUpdate(prevProps, prevState) {
    if (typeof window === 'undefined') return;
  
    const searchParams = new URLSearchParams(window.location.search);
    const categorySlug = searchParams.get('category');
  
    // Only update if the slug changed from current state
    if (
      (this.state.topic && this.state.topic.value !== categorySlug) ||
      (!this.state.topic && categorySlug !== null)
    ) {
      this.syncCategoryFromURL(categorySlug);
    }
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'mount':
        let { name, value } = option.currentTarget
        let item = this[name]?.props?.options?.find(el => el.value === value)
        if (item) {
          state[name] = item
        }
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    this.setState(state, this.updateList)
  }

  syncCategoryFromURL = () => {
    const { categories } = this.props;
    const searchParams = new URLSearchParams(window.location.search);
    const categorySlug = searchParams.get("category");
  
    let topic = null;
    if (categories && categorySlug) {
      const category = categories.find(el => el.slug === categorySlug);
      if (category) {
        topic = { label: category.name, value: category.slug };
      }
    }
  
    this.setState({ topic }, this.updateList);
  }

  updateList = () => {
    const { list, set } = this.props
    const { location, topic } = this.state

    let results = {}

    if (list) {
      results = list.filter((el, i) => {
        const { categories, tags } = el
        if (topic && !categories.nodes.find(el => el.slug === topic.value)) return false
        return true
      })
    }
    set(results)
  }

  render() {
    let { location, topic } = this.state
    let { categories, tags } = this.props

    let categoryOptions = []
    // loop over tags and categories and create options
    categories && categories.forEach(category => {
      categoryOptions.push({ label: category.name, value: category.slug })
    })
    // return the label inside categories array where the value matches type
    return (
      <div className='blog__sort search'>
        <div className="search__inner">
          <form className='search__form form'>
            <div className="form__row">
              <div className='form__select form__select--category'>
                <Select
                  options={categoryOptions}
                  onChange={this.handleSelectChange}
                  isSearchable={false}
                  openMenuOnFocus={true}
                  id="topic"
                  name="topic"
                  value={topic}
                  placeholder="All Topics"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.topic = node}
                />
              </div>
              <button className='form__submit' type='submit' onClick={(e) => e.preventDefault()}>Search</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default BlogSearch